import React from "react";
import { Button, makeStyles, Theme } from "@material-ui/core";
import { ChevronLeft } from "@material-ui/icons";

interface Props {
  label: string;
  onBack(): void;
}

export default function LeaderboardContextBar({ label, onBack }: Props) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Button
        className={classes.backButton}
        onClick={onBack}
        startIcon={<ChevronLeft className={classes.chevron} />}
        disableRipple
      >
        {label}
      </Button>
    </div>
  );
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: "100%",
    boxSizing: "border-box",
    padding: theme.spacing(0.75, 1.25, 0.5),
    borderBottom: `1px solid rgba(226, 232, 240, 0.95)`,
    backgroundColor: "#ffffff",
  },
  backButton: {
    justifyContent: "flex-start",
    textTransform: "none",
    fontWeight: 500,
    fontSize: "0.8125rem",
    color: "#475569",
    padding: theme.spacing(0.5, 0.75),
    minHeight: 40,
    "&:hover": {
      backgroundColor: "transparent",
      color: "#0f172a",
    },
    "&:active": {
      transform: "scale(0.98)",
    },
  },
  chevron: {
    fontSize: "1.25rem",
  },
}));
